<template>
    <nav class="navbar" :class="{ fixed: isFixed, show: isVisible }">
        <div class="nav-container">
            <!-- Logo -->
            <div class="logo">
               <a href="/"><img :src="logoImage" alt="LLTC LOGO" /></a> 
            </div>

            <!-- Desktop / Mobile Links -->
            <ul class="nav-links" :class="{ open: isOpen }">
                
                <!-- About Us Dropdown -->
                <li class="dropdown" @mouseenter="openDropdown('about')" @mouseleave="closeDropdown('about')">
                <a href="#">
                    About Us <span class="chevron"><img src="../assets/images/angle.svg" alt=""></span>
                </a>
                <ul v-show="dropdown.about" class="dropdown-menu">
                    <li><a href="/about-us">About Us</a></li>
                    <li><a href="/guest-info">Guest Info</a></li>
                    <li v-if="loggedId !== null"><a href="/club-policy">Club Policy</a></li>
                    <li v-else><a href="/login">Club Policy</a></li>
                </ul>
                </li>

                <!-- Membership Dropdown -->
                <li class="dropdown" @mouseenter="openDropdown('membership')" @mouseleave="closeDropdown('membership')">
                <a href="#">
                    Membership <span class="chevron"><img src="../assets/images/angle.svg" alt=""></span>
                </a>
                <ul v-show="dropdown.membership" class="dropdown-menu">
                    <li><a href="/membership-info">Membership Info</a></li>
                    <li><a href="/application-forms">Application Form</a></li>
                   
                </ul>
                </li>

                <!-- Programs (normal link) -->
                <li><a href="/program-overview">Programs</a></li>

                 <!-- Programs (normal link) -->
                 <li><a href="/photo-gallery">Photo Gallery</a></li>

                <!-- Events (normal link) -->
                <li><a href="/social-event">Events</a></li>

                <!-- Booking Dropdown -->
                <li class="dropdown" @mouseenter="openDropdown('booking')" @mouseleave="closeDropdown('booking')">
                <a href="#">
                    Booking <span class="chevron"><img src="../assets/images/angle.svg" alt=""></span>
                </a>
                <ul v-show="dropdown.booking" class="dropdown-menu">
                    <li><a href="/book-a-court">Book a Court</a></li>
                    <li><a href="/tournaments">Tournaments/Competitions</a></li>
                </ul>
                </li>

                <!-- Auth Buttons (inside mobile nav) -->
                <div class="authbuttons mobile-auth">
                    <button class="login" @click="handleLogin">Member Login</button>
                    <button class="register" @click="handleSignup">Join Now</button>
                </div>
            </ul>

            <!-- Desktop-only Auth buttons -->
            <div class="authbuttons desktop-auth" v-if="loggedId !== null">
                <button class="login" @click="dashboard">
                    <LayoutDashboard class="w-5 h-5" />
                    Dashboard
                </button>
                <button class="register" @click="handleSignout">Log Out</button>
            </div>
            <div class="authbuttons desktop-auth" v-else>
                <button class="login" @click="handleLogin">Member Login</button>
                <button class="register" @click="handleSignup">Join Now</button>
            </div>

            <!-- Hamburger (mobile) -->
            <button class="hamburger" @click="toggleMenu" aria-label="Toggle menu">
                <Menu v-if="!isOpen" size="28"/>
                <X v-else size="28" />
            </button>
        </div>
    </nav>
</template>

<script setup>
import { ref, onMounted, onUnmounted, onBeforeUnmount  } from "vue";
import { Menu, X } from "lucide-vue-next"
import router from "@/router";
import { reactive } from "vue";
import { LayoutDashboard } from "lucide-vue-next";
import axios from 'axios';

const isOpen = ref(false);
const loggedId = ref(localStorage.getItem('userid'));
const created_by = ref(localStorage.getItem('userid'));
let base_url = process.env.VUE_APP_BASE_LIVE_URL
//let base_url = "http://localhost:8888/lltc_backend/";

const logoImage = ref('');
const isFixed = ref(false);
const isVisible = ref(false);
let lastScrollY = 0;


const toggleMenu = () => {
    isOpen.value = !isOpen.value;
};

const dashboard = () => {
    router.push('/dashboard');
}
const handleLogin = () => {
    router.push('/login');
};
const handleSignup = () => {
    router.push('/register');
};

const handleSignout = () => {
     // Clear any hash from URL
     if (window.location.hash) {
        window.history.replaceState(null, null, window.location.pathname);
    }
    localStorage.removeItem("userid");
    localStorage.removeItem("username");
    localStorage.removeItem("email_address");
    localStorage.removeItem("user_role");
    localStorage.removeItem("jwt_token");
    localStorage.removeItem("member_id");
    created_by.value = null;
    window.location.href = "/";
    window.location.reload()
}
const dropdown = reactive({
  about: false,
  membership: false,
  booking: false,
});

const openDropdown = (menu) => {
  dropdown[menu] = true;
};

const closeDropdown = (menu) => {
  dropdown[menu] = false;
};

const handleScroll = () => {
  const currentScroll = window.scrollY;

  // When scrolling UP
  if (currentScroll < lastScrollY && currentScroll > 80) {
    isFixed.value = false;
    isVisible.value = true;
  }

  // When scrolling DOWN
  if (currentScroll > lastScrollY) {
    isFixed.value = true;
    isVisible.value = false;
  }

  lastScrollY = currentScroll;
};

onMounted( async () => {
  window.addEventListener("scroll", handleScroll);
  await listLogo();
  
})

onUnmounted( async () => {
  //window.removeEventListener('scroll', handleScroll)

})

onBeforeUnmount( async () => {
    window.removeEventListener("scroll", handleScroll);
})

const listLogo = async () => {
  try {
    const response = await axios.get('/logo_lists.php', { });
   const logoData = response.data.data[0];
    logoImage.value = `${base_url}${logoData.banner_image}`
    console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};

</script>

<style scoped lang="scss">
/* Navbar container */
.navbar {
    background: #fbfbfb;
    border: 1px solid #c7c1c1;
    width: 100%;
    border-radius: 60px;
    //position: fixed;
    top: 4;
    z-index: 1000;
}

.navbar.fixed {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: white;             /* or your color */
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  transform: translateY(-100%);
  animation: slideDown 0.3s forwards;
}

@keyframes slideDown {
  to { transform: translateY(0); }
}
.nav-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 10px;
    width: 100%;
}

/* Logo */
.logo img {
    max-height: 45px;
}

/* Nav links (desktop default) */
.nav-links {
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;

    a {
        text-decoration: none;
        color: #555555;
        font-family: "Open Runde", sans-serif;
        font-weight: 500;

        //font-family: "Open Runde";
        font-weight: 500;
        font-style: Medium;
        font-size: 17px;
        margin: 10px;

    }
}

/* Auth buttons */
.authbuttons {
    display: flex;
    gap: 1rem;

    .login {
        background-color: #ffffff;
        border: 1px solid #0000001f;
        color: black;
        border-radius: 30px;
        font-family: "Open Runde", sans-serif;
        padding: 10px 20px;
        cursor: pointer;
        transition: 0.3s ease;
        font-weight: 500;
        font-style: Medium;
        font-size: 18px;
    }

    .login:hover {
        border: 1px solid #ed4e24;
    }

    .register {
        background-color: #ed4e24;
        border: 1px solid #0000001f;
        color: white;
        border-radius: 30px;
        font-family: "Open Runde", sans-serif;
        padding: 10px 20px;
        cursor: pointer;
        transition: 0.3s ease;
        font-weight: 500;
        font-style: Medium;
        font-size: 18px;

    }

    .register:hover {
        background-color: #c63d1c;
    }
}

@media (max-width: 768px) {
    .authbuttons {
        .login {
            padding: 5px 10px;
            font-size: 14px;
        }

        .register {
            padding: 5px 10px;
            font-size: 14px;
        }
    }

}

/* Hamburger (hidden on desktop) */
.hamburger {
    display: none;
    flex-direction: column;
    background-color: transparent;
    border: none;
    gap: 5px;
    cursor: pointer;

    span {
        width: 25px;
        height: 3px;
        background: #333;
        border-radius: 2px;
    }
}


.mobile-auth {
    display: none;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  list-style: none;
  background: #fff;
  padding: 10px 0;
  margin: 0;
  display: block;
  min-width: 250px;
  border-radius: 6px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  border: 0;
}

.dropdown-menu li {
  padding: 2px 5px;
  border-bottom: 0.2px solid #00000033
}

.dropdown-menu li a {
  text-decoration: none;
  color: #333;
  display: block;
}

.dropdown-menu li:hover {
  background: #3333331d;
}

.chevron {
  font-size: 12px;
  margin-left: 4px;
}

@media (max-width: 768px) {

    .dropdown-menu {
        min-width: 220px;
    }

}

/* --- Responsive --- */
@media (max-width: 768px) {
    .logo img {
        max-height: 25px;
    }

    .navbar {
        background: #fbfbfb;
        border: 2px solid #c7c1c1;
        width: 100%;
        border-radius: 60px;
        position: sticky;
        top: 0;
        margin: auto;
        z-index: 1000;
    }

    .nav-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 5px 15px;
        width: 100%;
    }

    /* Show hamburger */
    .hamburger {
        display: flex;
    }

    /* Hide desktop auth buttons */
    .desktop-auth {
        display: none;
    }

    /* Nav links collapse */
    .nav-links {
        display: none;
        position: absolute;
        height: 350px;
        top: 60px;
        right: 0%;
        background: #fff;
        border-radius: 20px;
        flex-direction: column;
        align-items: flex-start;
        gap: 1rem;
        padding: 1rem;
        width: 250px;
        transition: max-height 0.3s ease-out;

        a {
            font-size: 15px;
         }
    }

    .nav-links.open {
        max-height: 400px;
        transition: max-height 0.3s ease-in;
    }

    .nav-links.open {
        display: flex;
    }

    /* Mobile auth inside dropdown */
    .mobile-auth {
        display: block;
        flex-direction: column;
        width: 100%;
        gap: 0.8rem;

        button {
            margin-top: 10px;
            width: 100%;
        }
    }
}
</style>
